module.exports = __webpack_public_path__ + "static/img/icon_liushi@2x.8687c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_liushi@2x.png
// module id = n9mA
// module chunks = 0